import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)] relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute -mx-4 w-full bg-gray-100 -bottom-16 md:right-2 right-3 h-16 pointer-events-none" }, null, -1)
const _hoisted_3 = { class: "min-h-screen p-8 bg-gray-100" }
const _hoisted_4 = { class: "lg:w-[90%] w-full mx-auto" }
const _hoisted_5 = { class: "grid grid-cols-3 lg:gap-8 gap-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "lg:col-span-2 col-span-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold lg:mb-7 lg:mt-2.5" }, "Dashboard")
], -1)
const _hoisted_7 = { class: "lg:col-span-1 col-span-3" }
const _hoisted_8 = { class: "flex items-center lg:justify-end mb-5 space-x-4" }
const _hoisted_9 = { class: "w-fit" }
const _hoisted_10 = { class: "grid grid-cols-3 md:gap-8 gap-4" }
const _hoisted_11 = { class: "lg:col-span-2 col-span-3" }
const _hoisted_12 = { class: "grid grid-cols-2 md:gap-8 gap-4" }
const _hoisted_13 = { class: "md:col-span-1 col-span-2 md:overflow-visible overflow-auto side-scroll" }
const _hoisted_14 = { class: "bg-white rounded-[10px] relative min-h-[180px] sm:min-w-[unset] min-w-[400px] h-full" }
const _hoisted_15 = { class: "relative w-full h-full" }
const _hoisted_16 = { class: "absolute top-0 left-0 z-0 w-full" }
const _hoisted_17 = { class: "flex items-start justify-between pl-[50px] pr-5 pt-5" }
const _hoisted_18 = { class: "flex items-center justify-between space-x-4" }
const _hoisted_19 = { class: "relative flex items-center justify-center w-16 h-16 mx-auto overflow-hidden rounded-full" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "absolute w-full h-full bg-primary-500 opacity-5" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-3 text-gray-700 leading-[14px]" }, " Total Offices ", -1)
const _hoisted_22 = { class: "font-bold text-2xl text-gray-700 leading-[26px]" }
const _hoisted_23 = {
  key: 0,
  class: "text-green-600 text-[0.688rem] font-semibold"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "md:block hidden absolute h-[110%] w-px bg-gray-500 -top-2 -right-4" }, null, -1)
const _hoisted_25 = { class: "md:col-span-1 col-span-2 md:overflow-visible overflow-auto side-scroll" }
const _hoisted_26 = { class: "bg-white rounded-[10px] overflow-hidden relative min-h-[180px] sm:min-w-[unset] min-w-[400px] h-full" }
const _hoisted_27 = { class: "absolute top-0 left-0 z-0 w-full" }
const _hoisted_28 = { class: "flex items-start justify-between pl-[50px] pr-5 pt-5" }
const _hoisted_29 = { class: "flex items-center justify-between space-x-4" }
const _hoisted_30 = { class: "relative flex items-center justify-center w-16 h-16 mx-auto overflow-hidden rounded-full" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "absolute w-full h-full bg-secondary-400 opacity-5" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-3 text-gray-700 leading-[14px]" }, " Total Personnel ", -1)
const _hoisted_33 = { class: "font-bold text-2xl text-gray-700 leading-[26px]" }
const _hoisted_34 = {
  key: 0,
  class: "text-green-600 text-[0.688rem] font-semibold"
}
const _hoisted_35 = { class: "col-span-2 bg-white rounded-[10px] overflow-hidden p-[30px]" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-bold text-gray-700" }, "Newly Added Personnel"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/personnel/index",
    class: "text-xs font-semibold transition text-primary-600 hover:text-primary-800"
  }, "See All")
], -1)
const _hoisted_37 = { class: "mt-8" }
const _hoisted_38 = { class: "px-6 py-2 text-xs text-gray-900 whitespace-nowrap" }
const _hoisted_39 = { class: "flex items-center px-6 py-2 text-xs text-gray-900 whitespace-nowrap" }
const _hoisted_40 = ["src"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "px-6 py-2 text-xs text-gray-900 whitespace-nowrap" }
const _hoisted_43 = { class: "px-6 py-2 text-xs text-gray-900 whitespace-nowrap" }
const _hoisted_44 = { class: "lg:col-span-1 col-span-3" }
const _hoisted_45 = { class: "grid grid-cols-2 md:gap-8 gap-4" }
const _hoisted_46 = { class: "col-span-2 bg-white rounded-[10px] overflow-hidden p-[30px]" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "mb-8 text-lg font-bold text-gray-700" }, "Personnel Status", -1)
const _hoisted_48 = { class: "flex flex-col space-y-5 dashboard_bargraph" }
const _hoisted_49 = { class: "grid grid-cols-[44px_1fr] gap-x-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[0.688rem]" }, "Verified")
], -1)
const _hoisted_51 = { class: "flex items-center col-span-1 space-x-4" }
const _hoisted_52 = { class: "text-xs" }
const _hoisted_53 = { class: "grid grid-cols-[58px_1fr] gap-x-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[0.688rem]" }, "Unverified")
], -1)
const _hoisted_55 = { class: "flex items-center col-span-1 space-x-4" }
const _hoisted_56 = { class: "text-xs" }
const _hoisted_57 = { class: "col-span-2 bg-white rounded-[10px] overflow-hidden p-[30px]" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", { class: "mb-8 text-lg font-bold text-gray-700" }, "Personnel Added by Month", -1)
const _hoisted_59 = { class: "flex flex-col space-y-5 dashboard_bargraph" }
const _hoisted_60 = { class: "col-span-1" }
const _hoisted_61 = { class: "text-[0.688rem]" }
const _hoisted_62 = { class: "flex items-center col-span-1 space-x-4" }
const _hoisted_63 = { class: "text-xs" }

import { ref, onMounted, watch, computed } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import DataTable from "@/components/partials/DataTable.vue";

import Dashboard from "@/classes/Dashboard/Dashboard";
import { useNetworkStore } from "@/store/network";
import PersonnelIcon from "@/components/icons/personnelIcon.vue";
import OfficeIcon from "@/components/icons/officeIcon.vue";
import { useRouter } from "vue-router";
import { useSecurityFeature } from "@/store/securityFeature";

import { Line } from "vue-chartjs";
import {
	Chart as ChartJS,
	Title,
	Tooltip,
	Legend,
	LineElement,
	BarElement,
	LinearScale,
	PointElement,
	CategoryScale,
	Filler,
	ArcElement,
} from "chart.js";
import { onIonViewWillEnter } from "@ionic/vue";
import Storage from "@/helpers/storage";
import { RoleTypes } from "../enums/RoleTypes";

const cartHeight = 100;
interface GraphInterface {
	labels: string,
	datasets: number[],
}

interface TotalInterface {
	total: number,
	new: number,
}

interface StatusPerMonthInterface {
	month: string,
	personnels: number,
	percentage: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();

ChartJS.register(
	Title,
	Tooltip,
	Legend,
	LineElement,
	BarElement,
	LinearScale,
	PointElement,
	CategoryScale,
	Filler,
	ArcElement
);

const grafLoading = ref<boolean>(false);

const dates = ref<Array<any>>([
	new Date(),
	new Date(new Date().setDate(new Date().getDate() + 7))
])

const tokens = new Storage();

const lineChartOptions = {
	responsive: true,
	maintainAspectRatio: false,
	plugins: {
		legend: {
			// position: "bottom",
			// align: "end",
			// reverse: true,

			display: false
		
		},
	},
	scales: {
		x: {
			offset: true,
			grid: {
				display: false,
			},
			ticks: {
				autoSkip: true,
				maxRotation: 0,
				minRotation: 0,
			},
		},
		y: {
			grid: {
				display: false,
			},
			beginAtZero: true,
		},
	},
};

const headers: { text: string; haveSort?: boolean }[] = [
	{ text: "ID", haveSort: true },
	{ text: "Name", haveSort: true },
	{ text: "Office", haveSort: true },
	{ text: "Date Added", haveSort: true },
];

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const personnelGraphData = ref<GraphInterface>({
	labels: '',
	datasets: [],
});

const officeGraphData = ref<GraphInterface>({
	labels: '',
	datasets: [],
});

const personnelTotal = ref<TotalInterface>({
	total: 0,
	new: 0,
})

const officeTotal = ref<TotalInterface>({
	total: 0,
	new: 0,
})

const newPersonnels = ref<any>([])

const accountStatus = ref<{
	verified: number
	unverified: number
	total: number
}>({
	verified: 0,
	unverified: 0,
	total: 0,
});


const statusPerMonth = ref<StatusPerMonthInterface[]>([]);

const init = (): void => {
	grafLoading.value = false

	Dashboard.index({dates: dates.value})
		.then(({ data }) => {
			personnelGraphData.value.labels = data.graphs.personnel_graph[0]
			personnelGraphData.value.datasets = data.graphs.personnel_graph[1]
			
			officeGraphData.value.labels = data.graphs.office_graph[0]
			officeGraphData.value.datasets = data.graphs.office_graph[1]

			personnelTotal.value =  data.total.personnel_total
			officeTotal.value = data.total.office_total
			
			newPersonnels.value = data.newPersonnels
			
			accountStatus.value = data.personnelAccountStatus
			
			statusPerMonth.value =  data.personnelStatusPerMonth
			
			grafLoading.value = true
		})
}

const checkHasPasswordBlocker = () => {
    const item = sessionStorage.getItem('hasPasswordBlocker');
    if (!item) {
        useSecurityFeature().isActivated = false;
        useSecurityFeature().isPasswordBlocker = true;
        sessionStorage.setItem('hasPasswordBlocker', true);
    }
}

const checkRoles = () => {
    const user = JSON.parse(tokens.get("user"));
    const wcpuRoles = [
        RoleTypes.OFFICE_ADMIN,
        RoleTypes.OFFICE_NORMAL,
        RoleTypes.NURSE,
        RoleTypes.WCPU,
        RoleTypes.OFFICE_TRAINEE,
    ]

    if(wcpuRoles.includes(user.role_id)){
        window.location.href = "/dashboard/wcpu";
    }
}


watch(
	() => dates.value,
	() => { 
		init();
	}
)

watch(
    () => isNetworkAvailable.value,
    (val) => {
        if (!val) {
            router.push('/patient/search');
        }
    }
);

onMounted(async() => {
    checkRoles();

    if (!isNetworkAvailable.value) {
        router.push('/patient/search');
        return;
    }

	init()	
})

onIonViewWillEnter(() => {
    if (isNetworkAvailable.value) {
        checkHasPasswordBlocker();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, { mainCustomClass: "!pb-0" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(DatePicker, {
                      id: "filter_from",
                      name: "filter_from",
                      range: true,
                      multiCalendars: "",
                      modelValue: dates.value,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((dates).value = $event)),
                        _cache[1] || (_cache[1] = (value) => (dates.value = value))
                      ],
                      class: "filter-range filter-dashboard"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createVNode(OfficeIcon, { class: "w-5 h-5 object-contain relative z-[1px]" }),
                                _hoisted_20
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_21,
                                _createElementVNode("p", _hoisted_22, _toDisplayString(officeTotal.value.total), 1)
                              ])
                            ]),
                            (officeTotal.value.new > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_23, "+" + _toDisplayString(officeTotal.value.new) + " New Added", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (grafLoading.value)
                          ? (_openBlock(), _createBlock(_unref(Line), {
                              key: 0,
                              options: lineChartOptions,
                              data: officeGraphData.value,
                              height: cartHeight
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_24
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(PersonnelIcon, { class: "w-5 h-5 object-contain relative z-[1px]" }),
                              _hoisted_31
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_32,
                              _createElementVNode("p", _hoisted_33, _toDisplayString(personnelTotal.value.total), 1)
                            ])
                          ]),
                          (personnelTotal.value.new > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_34, "+" + _toDisplayString(personnelTotal.value.new) + " New Added", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (grafLoading.value)
                        ? (_openBlock(), _createBlock(_unref(Line), {
                            key: 0,
                            options: lineChartOptions,
                            data: personnelGraphData.value,
                            height: cartHeight
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(DataTable, {
                        headers: headers,
                        "no-action": true,
                        count: newPersonnels.value.length,
                        tableClass: "header-frm-table dashboard__data-table",
                        dataTableClass: "border-0"
                      }, {
                        body: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newPersonnels.value, (item) => {
                            return (_openBlock(), _createElementBlock("tr", { key: item }, [
                              _createElementVNode("td", _hoisted_38, _toDisplayString(item.id), 1),
                              _createElementVNode("td", _hoisted_39, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("img", {
                                    class: "flex items-center justify-center rounded-full w-9 h-9 bg-secondary-600",
                                    src: item.profile_photo_url
                                  }, null, 8, _hoisted_40)
                                ]),
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_unref(router).replace(`/personnel/edit/${item.id}`)),
                                  class: "ml-2.5 text-primary-600 hover:text-primary-800 transition"
                                }, _toDisplayString(item.name), 9, _hoisted_41)
                              ]),
                              _createElementVNode("td", _hoisted_42, _toDisplayString(item.office_name), 1),
                              _createElementVNode("td", _hoisted_43, _toDisplayString(item.created_at_formatted), 1)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["count"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", {
                            class: "h-3 rounded-r-lg dashboard_bar",
                            style: _normalizeStyle({ 'width': (accountStatus.value.verified / accountStatus.value.total) * 100 + '%' })
                          }, null, 4),
                          _createElementVNode("span", _hoisted_52, _toDisplayString(accountStatus.value.verified), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", {
                            class: "h-3 rounded-r-lg dashboard_bar",
                            style: _normalizeStyle({ 'width': (accountStatus.value.unverified / accountStatus.value.total) * 100 + '%' })
                          }, null, 4),
                          _createElementVNode("span", _hoisted_56, _toDisplayString(accountStatus.value.unverified), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusPerMonth.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item,
                          class: "grid grid-cols-[24px_1fr] gap-x-2"
                        }, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("p", _hoisted_61, _toDisplayString(item.month), 1)
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", {
                              class: "h-3 rounded-r-lg dashboard_bar",
                              style: _normalizeStyle({ 'width': item.percentage + '%'})
                            }, null, 4),
                            _createElementVNode("span", _hoisted_63, _toDisplayString(item.personnels), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})